import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import activeWorkoutPreview from './slices/activeWorkoutPreview';
import activeWorkout from './slices/activeWorkout';
import activeWorkoutV5 from './slices/activeWorkoutV5';
import admin from './slices/admin';
import athleteProfile from './slices/athleteProfile';
import brand from './slices/brand';
import generator from './slices/generator';
import navigation from './slices/navigation';
import organization from './slices/organization';
import pendingEventsReducer from './slices/pendingEvents';
import programDefinition from './slices/programDefinition';
import simulationClock from './slices/simulationClock';
import trainer from './slices/trainer';
import trainingChart from './slices/trainingChart';
import user from './slices/user';
import viewWorkout from './slices/viewWorkout';
import whichWeightCache from './slices/whichWeightCache';

const rootReducer = combineReducers({
    activeWorkoutPreview,
    activeWorkout,
    activeWorkoutV5,
    admin,
    athleteProfile,
    brand,
    generator,
    navigation,
    organization,
    pendingEvents: pendingEventsReducer,
    programDefinition,
    simulationClock,
    trainer,
    trainingChart,
    user,
    viewWorkout,
    whichWeightCache
});

// Persisted reducer configuration
const persistConfig = {
    key: 'root',
    storage,
    // Specify which reducers you want to persist
    // whitelist: ['someReducer'], 
    // Specify which reducers you don't want to persist  
    blacklist: [
        'athleteProfile',
        'brand',
        'generator',
        'organization',
        'programDefinition',
        'trainer',
        'trainingChart',
        'user',
        'whichWeightCache'
    ]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'prod',
    middleware: [thunk]
});

export default store;